import { render, staticRenderFns } from "./Lgx329874561230987654.vue?vue&type=template&id=efc31398&scoped=true&"
import script from "./Lgx329874561230987654.vue?vue&type=script&lang=js&"
export * from "./Lgx329874561230987654.vue?vue&type=script&lang=js&"
import style0 from "./Lgx329874561230987654.vue?vue&type=style&index=0&id=efc31398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc31398",
  null
  
)

export default component.exports